export default __webpack_public_path__ + "static/media/screen_36.f112e1fc.png";